import React from 'react';
import styled from 'styled-components';
import Modal from '@designSystem/Modal';
import Button from '@designSystem/Button';
import { ToggleOff } from 'react-bootstrap-icons';
import ModalContentWithIcon from '@designSystem/Modal/ModalContentWithIcon';
import { useTranslation } from 'react-i18next';

interface ModalConfirmResiliationProps {
  show: boolean;
  onClose: () => void;
  onConfirmResiliation: () => void;
}

export const ModalConfirmResiliation: React.FC<ModalConfirmResiliationProps> = ({
  show,
  onClose,
  onConfirmResiliation
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      width="528px"
      show={show}
      onClose={onClose}
      {...{
        children: (
          <ContentModalResiliationStyled>
            <ModalContentWithIcon
              variant="red"
              title={t('service.modal.resiliation.title', 'Voulez-vous résilier ce service ?')}
              description={`${t(
                'service.modal.resiliation.description',
                'Cette action est irréversible.'
              )} ${t(
                'service.modal.resiliation.description_2',
                'Le statut de votre service sera modifié sous 24 heures.'
              )}`}
            >
              <ToggleOff />
            </ModalContentWithIcon>
            <div className="buttons-container">
              <Button design="reverse" variant="red" onClick={onClose}>
                {t('common.cancel', 'Annuler')}
              </Button>
              <Button variant="red" onClick={onConfirmResiliation}>
                {t('common.confirm', 'Confirmer')}
              </Button>
            </div>
          </ContentModalResiliationStyled>
        )
      }}
    />
  );
};

const ContentModalResiliationStyled = styled.div`
  .modal_content_icon {
    margin: 0 0 20px;
  }
  .buttons-container {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: auto auto;
    margin-top: 24px;
    height: 38px;
  }
`;
